import React from "react";

import SVGIcon from "./SVGIcon";

const Mag = (props: any) => (
  <SVGIcon
    className="svg-mag"
    pathD={[
      "m18.623 4.2559c-7.9132 0-14.367 6.454-14.367 14.367 0 7.9132 6.454 14.367 14.367 14.367 3.2414 0 6.2283-1.0954 8.6367-2.918a2.0002 2.0002 0 0 0 0.15039 0.16602l14.898 14.898a2.0002 2.0002 0 1 0 2.8281 -2.8281l-14.898-14.898a2.0002 2.0002 0 0 0 -0.16602 -0.15039c1.8225-2.4084 2.918-5.3953 2.918-8.6367 0-7.9132-6.454-14.367-14.367-14.367zm0 3.5898c5.9732 0 10.777 4.8042 10.777 10.777 0 5.9732-4.8042 10.777-10.777 10.777s-10.777-4.8042-10.777-10.777c2e-7 -5.9732 4.8042-10.777 10.777-10.777z",
    ]}
    width={25}
    fill="#555"
    height={25}
    viewBox="0 0 50.000001 50.000001"
    {...props}
  />
);

export default Mag;
